export type FlattenKeys<T> = T extends object
  ? {
      [K in keyof T]-?: T[K] extends string
        ? K extends string
          ? `${K}`
          : never
        : T[K] extends object
          ? K extends string
            ? `${K}.${FlattenKeys<T[K]>}`
            : never
          : never;
    }[keyof T]
  : never;

// Moved to @shared; re-exported here so existing internal imports keep working.
export { nameof } from "@shared";

type PartialTwoLevel<T> = {
  [P in keyof T]?: Partial<T[P]>;
};

export const partialArray = <T>(array: Array<PartialTwoLevel<T>>): T[] => array as T[];
export const partial = <T>(obj: PartialTwoLevel<T>): T => obj as T;

export type DateKeys<T> = {
  [K in keyof T]: T[K] extends Date ? K : never;
}[keyof T];

export const parseRouteParamDate = (value: string | null | undefined): Date | null => {
  if (!value) {
    return null;
  }
  const date = new Date(value); // ISO yyyy-MM-dd
  return isNaN(date.getTime()) ? null : date;
};

// Moved to @shared (FormDialog's extraAction uses it); re-exported here so existing internal
// imports keep working.
export type { AtLeastOne } from "@shared";

export function assertUnreachable(x: never): never {
  throw new Error(`Unhandled case: ${x}`);
}

export function emptyToNull(value: string): string | null {
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}
